import { c as _c } from "react/compiler-runtime";
import { Button, HStack, Input, VStack, Field } from '@chakra-ui/react';
import { AutoResizeTextarea } from '@src/components/sco/AutoResizeTextarea';
import { HelpModal } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/HelpModal';
import { PitchBuidlerFormProps } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/index';
import React, { useEffect, useState } from 'react';
export const BasicsSection: React.FC<PitchBuidlerFormProps> = props => {
  const $ = _c(48);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [companyName, setCompanyName] = useState(props.investorSearch.companyName || props.investorSearch.searchingCompany?.name || "");
  const [companyElevatorPitch, setCompanyElevatorPitch] = useState(props.investorSearch.companyElevatorPitch || "");
  const [companyWebsiteUrl, setCompanyWebsiteUrl] = useState(props.investorSearch.companyWebsiteUrl || "");
  let t0;
  if ($[0] !== props.investorSearch.companyName || $[1] !== props.investorSearch.companyWebsiteUrl || $[2] !== props.investorSearch.searchingCompany?.name) {
    t0 = () => {
      setCompanyName(props.investorSearch.companyName || props.investorSearch.searchingCompany?.name || "");
      setCompanyWebsiteUrl(props.investorSearch.companyWebsiteUrl);
    };
    $[0] = props.investorSearch.companyName;
    $[1] = props.investorSearch.companyWebsiteUrl;
    $[2] = props.investorSearch.searchingCompany?.name;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const t1 = props.investorSearch.searchingCompany?.name;
  let t2;
  if ($[4] !== props.investorSearch.companyElevatorPitch || $[5] !== props.investorSearch.companyName || $[6] !== props.investorSearch.companyWebsiteUrl || $[7] !== t1) {
    t2 = [props.investorSearch.companyName, t1, props.investorSearch.companyWebsiteUrl, props.investorSearch.companyElevatorPitch];
    $[4] = props.investorSearch.companyElevatorPitch;
    $[5] = props.investorSearch.companyName;
    $[6] = props.investorSearch.companyWebsiteUrl;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t0, t2);
  let t3;
  if ($[9] !== companyElevatorPitch || $[10] !== companyName || $[11] !== companyWebsiteUrl || $[12] !== props) {
    t3 = async t4 => {
      const next = t4 === undefined ? _temp : t4;
      if (!props.investorSearch.investorSearchId) {
        alert("Cannot save, record not loaded yet.");
        return;
      }
      await props.upsertInvestorSearch({
        variables: {
          input: {
            investorSearchId: props.investorSearch.investorSearchId,
            companyName,
            companyWebsiteUrl,
            companyElevatorPitch
          }
        }
      });
      if (next) {
        next();
      }
    };
    $[9] = companyElevatorPitch;
    $[10] = companyName;
    $[11] = companyWebsiteUrl;
    $[12] = props;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const performSave = t3;
  let t4;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Field.Label>Company Name</Field.Label>;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== performSave) {
    t5 = ev => performSave();
    $[15] = performSave;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e => setCompanyName(e.target.value);
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== companyName || $[19] !== t5) {
    t7 = <Field.Root>{t4}<Input placeholder="Acme Inc." size="sm" value={companyName} onBlur={t5} onChange={t6} /></Field.Root>;
    $[18] = companyName;
    $[19] = t5;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Field.Label>Website URL</Field.Label>;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== performSave) {
    t9 = ev_0 => performSave();
    $[22] = performSave;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = e_0 => setCompanyWebsiteUrl(e_0.target.value);
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== companyWebsiteUrl || $[26] !== t9) {
    t11 = <Field.Root>{t8}<Input placeholder="https://www.acme.com" size="sm" value={companyWebsiteUrl} onBlur={t9} onChange={t10} /></Field.Root>;
    $[25] = companyWebsiteUrl;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Field.Label>Elevator Pitch</Field.Label>;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== performSave) {
    t13 = ev_1 => performSave();
    $[29] = performSave;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = e_1 => setCompanyElevatorPitch(e_1.target.value);
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== companyElevatorPitch || $[33] !== t13) {
    t15 = <Field.Root>{t12}<AutoResizeTextarea maxHeight="200px" placeholder="Brief explanation of what you do." size="sm" value={companyElevatorPitch} onBlur={t13} onChange={t14} /></Field.Root>;
    $[32] = companyElevatorPitch;
    $[33] = t13;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== performSave || $[36] !== props) {
    t16 = <HStack justify="flex-end" padding={2} width="full"><Button size="xs" variant="cta" onClick={async e_2 => {
        await performSave(() => props.onNextSection?.());
      }}>{"Save & Continue"}</Button></HStack>;
    $[35] = performSave;
    $[36] = props;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t11 || $[39] !== t15 || $[40] !== t16 || $[41] !== t7) {
    t17 = <VStack align="stretch" gap={6} padding={4}>{t7}{t11}{t15}{t16}</VStack>;
    $[38] = t11;
    $[39] = t15;
    $[40] = t16;
    $[41] = t7;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== showHelpModal) {
    t18 = <HelpModal setShowHelpModal={setShowHelpModal} showHelpModal={showHelpModal} />;
    $[43] = showHelpModal;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t17 || $[46] !== t18) {
    t19 = <>{t17}{t18}</>;
    $[45] = t17;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  return t19;
};
function _temp() {}